import { getGuidLabel } from 'customer-data-objects/property/knownGuidUtils';
import { usePropertyValue } from '../hooks/usePropertyValue';
import { getDataAttributes } from '../../utils/getDataAttributes';
import useComponentMountMetric from '../../metrics/useComponentMountMetric';
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPropertyKnownGuid = props => {
  useComponentMountMetric('FormattedPropertyKnownGuid');
  const propertyValue = usePropertyValue();
  const {
    placeholder
  } = props;
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: propertyValue ? getGuidLabel(propertyValue) : placeholder
  }));
};
FormattedPropertyKnownGuid.displayName = 'FormattedPropertyKnownGuid';
export default FormattedPropertyKnownGuid;